import { styled } from 'styled-components';
import { SchoolLookup, crTheme } from '@comicrelief/component-library';
import { ReusableInputStyles } from '../../components/global/Global.style';

export const StyledSchoolLookup = styled(SchoolLookup)`
  ${ReusableInputStyles}
  width: 100%;
  position: relative;

  > div {
    position: relative;
    width: 100%;
  }

  input {
    width: 100%;
    max-width: none;
    padding: 1rem 1.5rem;
    border-radius: 0.5rem;
    font-size: 1.125rem;
    line-height: 1.5rem;
  }

  button {
    display: none;
  }

  /* Target the results list, and make it appear below the input field, and match its width */
  div:has([role="listbox"]) {
    border: 1px solid ${crTheme.color('grey')};
    border-radius: 0.5rem;
    position: absolute;
    top: 100%;
    left: 0;
    right: auto;
    width: 100%;
    margin-top: 8px ;
  }

  [role="listbox"] {
    width: 100%;
    z-index: 1;
    overflow: hidden;

    li {
      padding: 1rem 1.5rem;
      cursor: pointer;

      &:hover {
        background-color: ${crTheme.color('grey_light')};
      }
    }
  }
`;
